export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.26-1707.02',
  commitId: 'a66a61654ac6357dbeaa6a1d7707c20bfa342e2b',
  commitTime: '2026-03-26T17:07:02.000Z',
});
